// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1NGt4","description":"PatientConsentPreview_description__3VjmF"};